export const UNSAVED_WORK_EVENT = 'eightbots-unsaved-work';
export type UnsavedWorkQuery = CustomEvent<{blocked: boolean}>;

/** Each mounted editor reports its own draft or active write without copying it. */
export function ownerHasUnsavedWork(): boolean {
  const event: UnsavedWorkQuery = new CustomEvent(UNSAVED_WORK_EVENT, {detail: {blocked: false}});
  window.dispatchEvent(event);
  return event.detail.blocked;
}
